import { LinkDetails } from "../types/homePageCategoryTypes";

export const homePageCategoryLinkCreationInitialValues: LinkDetails = {
  id: "",
  href: "",
  name: "",
  nameEn: "",
  order: 1,
  active: true,
  accessRoles: [],
};
